// extracted by mini-css-extract-plugin
export default {"container":"SupplierClients_container__5Duxv","button":"SupplierClients_button__v3aQf","searchWrapper":"SupplierClients_searchWrapper__oYJw5"};